import React from 'react';
import { StyleSheet, View } from 'react-native';
import { CvPreview } from './CvPreview';
import { colors, radius } from '../theme/tokens';
import type { CvTemplate, GeneratedCv } from '../types';
import { PROPS_LTR } from '../i18n/sens';
import { SensTexteLtr } from './Texte';

// Largeur de rendu interne déterministe : CvPreview est rendu à cette largeur, puis mis à l'échelle.
const NATURAL_WIDTH = 360;

export interface CvMiniatureProps {
  cv: GeneratedCv;
  name?: string;
  title?: string;
  email?: string;
  phone?: string;
  address?: string;
  linkedin?: string;
  template?: CvTemplate;
  accentColor?: string;
  width?: number;
  height?: number;
  testID?: string;
}

// Miniature FIDÈLE du CV : le vrai composant CvPreview (= rendu de l'export) réduit par transform.
// Cadre à taille fixe + overflow caché, calé en haut-gauche → on voit le haut du CV (en-tête + 1res
// sections), le reste rogné proprement. Pas d'image, pas de module natif, pas de délai.
export function CvMiniature({
  cv,
  name,
  title,
  email,
  phone,
  address,
  linkedin,
  template = 'mono',
  accentColor,
  width = 120,
  height = 160,
  testID,
}: CvMiniatureProps) {
  const scale = width / NATURAL_WIDTH;

  return (
    <View testID={testID} style={[styles.frame, { width, height }]} pointerEvents="none" {...PROPS_LTR}>
      <SensTexteLtr>
        <View style={[styles.scaled, { transform: [{ scale }] }]}>
          <CvPreview
            cv={cv}
            name={name}
            title={title}
            email={email}
            phone={phone}
            address={address}
            linkedin={linkedin}
            template={template}
            accentColor={accentColor}
          />
        </View>
      </SensTexteLtr>
    </View>
  );
}

const styles = StyleSheet.create({
  // Document en français : jamais retourné en droite à gauche (i18n/sens.ts).
  frame: {
    direction: 'ltr',
    backgroundColor: colors.white,
    borderRadius: radius.sm,
    borderWidth: 1,
    borderColor: colors.grey200,
    overflow: 'hidden',
  },
  scaled: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: NATURAL_WIDTH,
    transformOrigin: 'top left',
  },
});
